export default "__VITE_ASSET__CRaTrTXu__"